export function floatSeparator(value) {
    if (value) {
        value = value.toFixed(2)
        if (value < 0) {
            value = value * -1
            return '-$' + value.toString().replace(/\B(?=(\d{3})+\.)/g, ',')
        } else {
            return '$' + value.toString().replace(/\B(?=(\d{3})+\.)/g, ',')
        }
    } else if (value === 0) {
        return '$0.00'
    } else {
        return ''
    }
}
export function numSeparator(value) {
    if (value || value == 0) {
        return value.toString().replace(/\B(?=(\d{3})+$)/g, ',')
    }
}
export function formatDate(date, format) {
    if (!date) return
    if (!format) format = 'yyyy-MM-dd HH:mm:ss'
    switch (typeof date) {
    case 'string':
        date = new Date(date.replace(/-/, '/'))
        break
    case 'number':
        date = new Date(date)
        break
    }
    if (!date instanceof Date) return
    let dict = {
        yyyy: date.getFullYear(),
        M: date.getMonth() + 1,
        d: date.getDate(),
        H: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds(),
        MM: ('' + (date.getMonth() + 101)).substr(1),
        dd: ('' + (date.getDate() + 100)).substr(1),
        HH: ('' + (date.getHours() + 100)).substr(1),
        mm: ('' + (date.getMinutes() + 100)).substr(1),
        ss: ('' + (date.getSeconds() + 100)).substr(1)
    }
    return format.replace(/(yyyy|MM?|dd?|HH?|ss?|mm?)/g, function() {
        return dict[arguments[0]]
    })
}



// WEBPACK FOOTER //
// ./src/assets/js/util.js